// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"50967a43","196":"b733994d","282":"d35a023c","563":"44b7dc82","714":"3a8ee0f7","812":"74ac4fff"}[chunkId] + ".chunk.js";
};